import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ e("path", { d: "M7.685 7.31a.686.686 0 1 0 0 1.37h2.524l-.769.77a.686.686 0 0 0 .97.97l1.939-1.94a.686.686 0 0 0 0-.97l-1.94-1.94a.686.686 0 1 0-.969.97l.769.77H7.685Z" }, null, -1), c = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M1.33 4.32c0-.95.77-1.72 1.72-1.72h9.891c.95 0 1.72.77 1.72 1.72v7.366c0 .95-.77 1.72-1.72 1.72H3.05a1.72 1.72 0 0 1-1.719-1.72V4.32Zm1.474 7.366c0 .136.11.246.245.246H4.5V4.074H3.05a.246.246 0 0 0-.246.245v7.367Zm3.17-7.612v7.858h6.967c.136 0 .246-.11.246-.246V4.32a.246.246 0 0 0-.246-.245H5.973Z",
  "clip-rule": "evenodd"
}, null, -1), a = [
  n,
  c
];
function d(r, s) {
  return t(), o("svg", l, [...a]);
}
const p = { render: d };
export {
  p as default,
  d as render
};
